module.exports = __webpack_public_path__ + "img/red.e5000271.png";